
b64EncodeUnicode = (str) ->
    # // first we use encodeURIComponent to get percent-encoded UTF-8,
    # // then we convert the percent encodings into raw bytes which
    # // can be fed into btoa.
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
        (match, p1) ->
            return String.fromCharCode('0x' + p1)
    ))

uuid4 = ->
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace /[xy]/g, (c) ->
    r = Math.random() * 16 | 0
    v = if c == 'x' then r else r & 0x3 | 0x8
    v.toString 16

# ---

export default {
    "deep_copy": (obj)->
        return JSON.parse(JSON.stringify(obj))
    "b64_encode": b64EncodeUnicode,
    "uuid4": uuid4
}
